import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import api from '../../api/api';
import Sidebar from '../../components/Sidebar';
import '../../styles/ReportsPage.css';
import '../../styles/DashboardLayout.css';

const ReportsListPage = () => {
  const [classes, setClasses] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [sidebarOpen, setSidebarOpen] = useState(false);

  // Toggle sidebar
  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  // Close sidebar
  const closeSidebar = () => {
    setSidebarOpen(false);
  };

  useEffect(() => {
    const fetchClasses = async () => {
      try {
        setLoading(true);
        
        // Fetch all classes (halaqas)
        const classesResponse = await api.get('/halaqas');
        
        const classesData = classesResponse.data.success 
          ? classesResponse.data.data 
          : classesResponse.data;
        
        const classesArray = Array.isArray(classesData) ? classesData : [];
        
        // Fetch student counts for each class
        const classesWithCounts = await Promise.all(
          classesArray.map(async (classItem) => {
            try {
              // Fetch students for each class
              const studentsResponse = await api.get(`/halaqas/${classItem._id}/students`);
              const studentsData = studentsResponse.data.success
                ? studentsResponse.data.data
                : studentsResponse.data;
              
              // Return class with student count added
              return {
                ...classItem,
                studentCount: Array.isArray(studentsData) ? studentsData.length : 0
              };
            } catch (err) {
              console.error(`Error fetching students for class ${classItem._id}:`, err);
              return {
                ...classItem,
                studentCount: 0
              };
            }
          })
        );
        
        setClasses(classesWithCounts);
      } catch (err) {
        console.error('Error fetching classes:', err);
        setError('Failed to load classes. Please try again later.');
      } finally {
        setLoading(false);
      }
    };

    fetchClasses();
  }, []);

  return (
    <div className="dashboard-container">
      {/* Mobile Header - without hamburger menu */}
      <div className="mobile-header">
        <h1 className="app-title">Class Reports</h1>
        <div className="avatar">👤</div>
      </div>

      {/* Dashboard Layout */}
      <div className="dashboard-layout">
        {/* Sidebar */}
        <Sidebar isOpen={sidebarOpen} onClose={closeSidebar} />
        
        {/* Main Content */}
        <div className="dashboard-content">
          <div className="reports-container">
            <div className="header">
              <div className="header-left">
                <Link to="/dashboard" className="back-to-dashboard">
                  &larr; Back to Dashboard
                </Link>
                <h1>Class Reports</h1>
              </div>
            </div>

      {loading ? (
        <div className="loading">Loading classes...</div>
      ) : error ? (
        <div className="error">{error}</div>
      ) : (
        <div className="reports-grid">
          {classes.length > 0 ? (
            classes.map(classItem => (
              <div 
                key={classItem._id} 
                className={`report-card ${classItem.active ? 'active' : 'inactive'}`}
              >
                <div className="report-header">
                  <h2>{classItem.name}</h2>
                  <span className={`status-badge ${classItem.active ? 'status-active' : 'status-inactive'}`}>
                    {classItem.active ? 'Active' : 'Inactive'}
                  </span>
                </div>
                
                <div className="report-meta">
                  <div className="meta-item">
                    <span className="label">Students:</span>
                    <span className="value">{classItem.studentCount || 0}</span>
                  </div>
                  <div className="meta-item">
                    <span className="label">Teachers:</span>
                    <span className="value">{classItem.teachers?.length || 0}</span>
                  </div>
                </div>
                
                <div className="report-actions">
                  <Link to={`/reports/class/${classItem._id}`} className="view-report-btn">
                    View Class Report
                  </Link>
                </div>
              </div>
            ))
          ) : (
            <div className="no-results">
              <p>No classes found. Create a class to generate reports.</p>
              <Link to="/classes/new" className="create-class-btn">
                Create New Class
              </Link>
            </div>
          )}
        </div>
      )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReportsListPage;